// extracted by mini-css-extract-plugin
export var colorSquare = "_oc-0";
export var danger = "_oc-5";
export var lightPink = "_oc-8";
export var neutralBlue = "_oc-7";
export var neutralYellow = "_oc-6";
export var normal = "_oc-1";
export var primary = "_oc-2";
export var primaryLight = "_oc-3";
export var solidBlack = "_oc-g";
export var solidGreen = "_oc-b";
export var solidLightBlue = "_oc-d";
export var solidNavy = "_oc-c";
export var solidOrange = "_oc-f";
export var solidPink = "_oc-e";
export var solidRed = "_oc-9";
export var solidYellow = "_oc-a";
export var success = "_oc-4";